/**
 * Custom multicolumn: mobile slider (CSS transform) + dots. No overflow scroll strip.
 */
(function () {
  const mqMobile = window.matchMedia('(max-width: 749px)');

  /** @param {HTMLElement} root */
  function initRoot(root) {
    if (typeof root._cmcCleanup === 'function') root._cmcCleanup();

    const viewport = root.querySelector('[data-custom-multicolumn-viewport]');
    const track = root.querySelector('[data-custom-multicolumn-track]');
    const dotsHost = root.querySelector('[data-custom-multicolumn-dots]');
    if (!viewport || !track || !dotsHost) return;

    /** @returns {HTMLElement[]} */
    function getSlides() {
      return [...track.children].filter((c) => c instanceof HTMLElement);
    }

    let slides = getSlides();
    if (slides.length === 0) return;

    /** @type {HTMLButtonElement[]} */
    const dotEls = [];
    let current = 0;

    function buildDots() {
      slides = getSlides();
      dotsHost.innerHTML = '';
      dotEls.length = 0;
      const n = slides.length;
      for (let i = 0; i < n; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'custom-multicolumn-carousel__dot';
        btn.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + n);
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        const idx = i;
        btn.addEventListener('click', () => goTo(idx));
        dotsHost.appendChild(btn);
        dotEls.push(btn);
      }
    }

    function setDotsSelected(index) {
      dotEls.forEach((b, i) => b.setAttribute('aria-selected', i === index ? 'true' : 'false'));
    }

    function goTo(index) {
      slides = getSlides();
      const n = slides.length;
      if (n === 0) return;
      current = Math.max(0, Math.min(index, n - 1));

      if (!mqMobile.matches) {
        track.style.transform = '';
        setDotsSelected(current);
        return;
      }

      const slide = slides[current];
      if (slide) {
        track.style.transform = 'translate3d(' + -slide.offsetLeft + 'px, 0, 0)';
      }
      setDotsSelected(current);
    }

    function onMqOrResize() {
      if (mqMobile.matches) goTo(current);
      else {
        track.style.transform = '';
        setDotsSelected(current);
      }
    }

    let resizeTick = false;
    function scheduleResize() {
      if (resizeTick) return;
      resizeTick = true;
      requestAnimationFrame(() => {
        resizeTick = false;
        onMqOrResize();
      });
    }

    buildDots();
    goTo(0);

    const SWIPE_MIN_PX = 35;
    let touchStartX = 0;
    let touchStartY = 0;
    /** @type {number | null} */
    let activeTouchId = null;

    function onTouchStart(e) {
      if (!mqMobile.matches || e.touches.length !== 1) return;
      const t = e.touches[0];
      activeTouchId = t.identifier;
      touchStartX = t.clientX;
      touchStartY = t.clientY;
    }

    function onTouchMove(e) {
      if (!mqMobile.matches || activeTouchId === null) return;
      const t = [...e.touches].find((c) => c.identifier === activeTouchId);
      if (!t) return;
      const dx = t.clientX - touchStartX;
      const dy = t.clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
        e.preventDefault();
      }
    }

    function onTouchEnd(e) {
      if (!mqMobile.matches || activeTouchId === null) return;
      const t = [...e.changedTouches].find((c) => c.identifier === activeTouchId);
      activeTouchId = null;
      if (!t) return;
      const dx = t.clientX - touchStartX;
      const dy = t.clientY - touchStartY;
      if (Math.abs(dx) < SWIPE_MIN_PX) return;
      if (Math.abs(dx) < Math.abs(dy)) return;
      e.preventDefault();
      if (dx < 0) goTo(current + 1);
      else goTo(current - 1);
    }

    function onTouchCancel() {
      activeTouchId = null;
    }

    /** Capture on viewport so swipes starting on links/buttons inside slides still work. */
    const capStart = { passive: true, capture: true };
    const capMove = { passive: false, capture: true };
    const capEnd = { passive: false, capture: true };
    viewport.addEventListener('touchstart', onTouchStart, capStart);
    viewport.addEventListener('touchmove', onTouchMove, capMove);
    viewport.addEventListener('touchend', onTouchEnd, capEnd);
    viewport.addEventListener('touchcancel', onTouchCancel, capStart);

    window.addEventListener('resize', scheduleResize);
    mqMobile.addEventListener('change', onMqOrResize);

    root.dataset.customMulticolumnCarouselReady = 'true';
    root._cmcCleanup = function () {
      viewport.removeEventListener('touchstart', onTouchStart, capStart);
      viewport.removeEventListener('touchmove', onTouchMove, capMove);
      viewport.removeEventListener('touchend', onTouchEnd, capEnd);
      viewport.removeEventListener('touchcancel', onTouchCancel, capStart);
      window.removeEventListener('resize', scheduleResize);
      mqMobile.removeEventListener('change', onMqOrResize);
      track.style.transform = '';
      delete root._cmcCleanup;
      delete root.dataset.customMulticolumnCarouselReady;
    };
  }

  function initAllIn(node) {
    node.querySelectorAll('[data-custom-multicolumn-carousel]').forEach((el) => {
      if (el instanceof HTMLElement) initRoot(el);
    });
  }

  document.addEventListener('shopify:section:unload', (e) => {
    if (!(e.target instanceof HTMLElement)) return;
    e.target.querySelectorAll('[data-custom-multicolumn-carousel]').forEach((el) => {
      if (el instanceof HTMLElement && typeof el._cmcCleanup === 'function') el._cmcCleanup();
    });
  });

  document.addEventListener('shopify:section:load', (e) => {
    if (!(e.target instanceof HTMLElement)) return;
    initAllIn(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllIn(document), { once: true });
  } else {
    initAllIn(document);
  }
})();
